import React, { Component } from "react";
import PropTypes from "prop-types";
import { withTheme } from "styled-components";
import { Card, Button } from "@vitalsource/vstui";
import classnames from "classnames";
import styled from "styled-components";
import { MinusCircle } from "@vitalsource/vstui-icons";
import { actions as bridgeActions } from "../../../../redux/bridge";
import { t } from "../../../core/translate";
import { actions as routerActions } from "../../../../redux/router";
import { magic } from "@vitalsource/vstui/colors";
import {
  PrimaryTransparentButton,
  SecondaryButtons
} from "./../book/BookIcons";
import {
  PROMOTION_TOTAL_WIDTH,
  PROMOTION_TOTAL_HEIGHT,
  PROMOTION_COVER_HEIGHT,
  PROMOTION_TEXT_HEIGHT,
  AFFILIATE_URL,
  FREE_SUBSCRIPTION
} from "./promotionConsts";
import PromotionBadge from "./promotion-badge";
import { promotionToast } from "./toastUtils";
import { connect } from "react-redux";
import { OffScreenComponent } from "../../../components/mixins";

const TITLE_SIDE_PADDING_EM = 0.873;
const subscriptionRoute = vbid => `explore/${vbid}`;

export const OffScreenSpan = OffScreenComponent.withComponent("span");

const PromoButtons = styled.div`
  order: 2;
  opacity: 0;
  margin-right: 1000px;
  margin-left: -1000px;
  width: 100%;
  left: 0;
  padding: 10px 50px 44px 50px;
`;

const ButtonWrapper = styled.div`
  height: ${PROMOTION_TOTAL_HEIGHT}px;
  position: absolute;
  top: 0px;
  width: 100%;
  text-align: right;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: ${TITLE_SIDE_PADDING_EM}em ${TITLE_SIDE_PADDING_EM}em
    ${PROMOTION_TEXT_HEIGHT}px;
  &:active,
  &:focus,
  &:hover,
  &.hasFocus {
    ${PromoButtons},
    ${SecondaryButtons} {
      opacity: 1;
      margin-right: 0px;
      margin-left: 0px;
    }
  }
`;

const STYLED = {
  PromoContainer: styled.div`
    position: relative;
    cursor: pointer;
    .promo-cover-container {
      overflow: hidden;
      &:after {
        pointer-events: none;
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: ${PROMOTION_COVER_HEIGHT}px;
        opacity: 0;
        transition: opacity 200ms;
        background: linear-gradient(
          -180deg,
          rgba(0, 0, 0, 0.8) 0%,
          rgba(0, 0, 0, 0.4) 100%
        );
        /* Fix corner flashing during transition in Safari */
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
      }
    }
    ${props => `height: ${props.height}px;`}
    ${props => `width: ${props.width}px;`}
  &:hover,
  &:focus,
  &.hasFocus {
      .promo-cover-container {
        overflow: hidden;
        &:after {
          opacity: 1;
        }
      }
      .promo-cover-inner-container {
        filter: blur(5px);
      }
    }
  `,
  CoverImage: styled.div`
    ${p =>
      p.url
        ? `background-color: #262d40;`
        : `background-color: ${magic.getShade(9)};`}
    align-items: center;
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    height: ${PROMOTION_COVER_HEIGHT}px;
    justify-content: center;
    z-index: 2;
    &:before {
      ${p => p.url && `background-image: url(${p.url});`}
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      content: " ";
      display: block;
      height: ${PROMOTION_COVER_HEIGHT}px;
      left: 0;
      opacity: 0.4;
      width: 100%;
      z-index: 1;
    }
  `,
  CoverTitle: styled.div`
    align-items: center;
    color: #ffffff;
    display: flex;
    font-size: 2.6rem;
    font-weight: 500;
    height: ${PROMOTION_COVER_HEIGHT}px;
    justify-content: center;
    position: absolute;
    text-align: center;
    top: 0;
    width: 100%;
    z-index: 3;
  `,
  Description: styled.div`
    color: #1c1c1c;
    font-size: 1.6rem;
    font-weight: 400;
    height: 100px;
    padding: 20px 15px 15px 15px;
    text-align: left;
  `
};

class PromotionElement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      clickable: true,
      focus: false
    };
  }

  buttonTouchStart(e) {
    e.stopPropagation();
  }

  focusOn = () => {
    this.setState({ focus: true });
  };

  focusOff = () => {
    this.setState({ focus: false });
  };

  clickCover = () => {
    const { activatePromotion, active, routeTo, type, value } = this.props;
    if (type === AFFILIATE_URL) {
      window.open(value, "_blank");
    } else if (active) {
      routeTo(subscriptionRoute(value));
    } else if (this.state.clickable && !active) {
      this.focusOff();
      activatePromotion();
    }
  };

  renderButtons() {
    const {
      activatePromotion,
      active,
      deactivatePromotion,
      routeTo,
      simulateFocus,
      title,
      type,
      value
    } = this.props;

    const getButtonText = (type, active) => {
      if (type === AFFILIATE_URL) {
        return t("promotions.view-offers");
      } else if (active) {
        return t("promotions.view-subscription");
      }
      return t("promotions.activate-view");
    };

    const deactivateButton = () => {
      if (active && type === FREE_SUBSCRIPTION) {
        return (
          <Button
            data-testid="PromotionElement-DeactivateButton"
            color="white"
            iconEnd={<MinusCircle />}
            label={t("promotions.deactivate")}
            naked
            onBlur={this.focusOff}
            onFocus={this.focusOn}
            onTouchStart={this.buttonTouchStart}
            size="small"
            onClick={e => {
              // Stop event from triggering cover clicks
              e.stopPropagation();
              e.preventDefault();
              this.focusOff();
              deactivatePromotion();
              promotionToast(
                t(
                  "promotions.not-active",
                  "Subscription is no longer active.",
                  {
                    title
                  }
                )
              );
            }}
          >
            {t("promotions.deactivate")}
          </Button>
        );
      }
    };

    const primaryButtonClick = e => {
      e.stopPropagation();
      e.preventDefault();

      if (this.state.clickable) {
        if (type === AFFILIATE_URL) {
          window.open(value, "_blank");
        } else if (active) {
          routeTo(subscriptionRoute(this.props.value));
        } else {
          promotionToast(
            t("promotions.now-active", "Subscription is now active.", {
              title
            })
          );
          activatePromotion().then(() =>
            routeTo(subscriptionRoute(this.props.value))
          );
        }
      }
    };

    return (
      <ButtonWrapper
        className={classnames({
          hasFocus: simulateFocus || this.state.focus
        })}
      >
        <PromoButtons>
          <PrimaryTransparentButton
            fullWidth
            onClick={primaryButtonClick}
            onFocus={this.focusOn}
            onBlur={this.focusOff}
            onTouchStart={this.buttonTouchStart}
            data-testid="PromotionElement-PrimaryTransparentButton"
          >
            <OffScreenSpan>
              {title}{" - "}
            </OffScreenSpan>
            {getButtonText(type, active)}
          </PrimaryTransparentButton>
        </PromoButtons>
        <SecondaryButtons>{deactivateButton()}</SecondaryButtons>
      </ButtonWrapper>
    );
  }

  render() {
    const { title, type, description, simulateFocus, cover } = this.props;

    if (type) {
      return (
        <Card raised>
          <STYLED.PromoContainer
            width={PROMOTION_TOTAL_WIDTH}
            height={PROMOTION_TOTAL_HEIGHT}
            onTouchStart={() =>
              this.setState({
                clickable: false
              })
            }
            onTouchEnd={() =>
              setTimeout(() => {
                this.setState({ clickable: true });
              }, 250)
            }
            onClick={this.clickCover}
            className={classnames({
              hasFocus: simulateFocus || this.state.focus
            })}
            data-testid="PromotionElement-PromotionContainer"
          >
            <div className="promo-cover-container">
              <div className="promo-cover-inner-container">
                <STYLED.CoverImage
                  data-testid="PromotionElement-CoverImage"
                  url={type !== AFFILIATE_URL && cover}
                />
                <STYLED.CoverTitle data-testid="PromotionElement-CoverTitle">
                  {title}
                </STYLED.CoverTitle>
              </div>
            </div>
            <PromotionBadge type={type} />
            <STYLED.Description data-testid="PromotionElement-description">
              {description && description.decodeHTML()}
            </STYLED.Description>
            {this.renderButtons()}
          </STYLED.PromoContainer>
        </Card>
      );
    }
    return null;
  }
}

PromotionElement.defaultProps = {
  width: PROMOTION_TOTAL_WIDTH,
  height: PROMOTION_TOTAL_HEIGHT
};

PromotionElement.propTypes = {
  title: PropTypes.string.isRequired
};

const mapDispatchToProps = (dispatch, props) => ({
  activatePromotion: () =>
    dispatch(bridgeActions.activatePromotion(props.value)),
  deactivatePromotion: () =>
    dispatch(bridgeActions.deactivatePromotion(props.value)),
  routeTo: path => dispatch(routerActions.push(path))
});

export default connect(null, mapDispatchToProps)(withTheme(PromotionElement));
